/* "See it on your bike": a side-on photo, four taps on the frame, and a flat drawing of one of our frame bags laid into it.
   The four taps are the inside corners of the frame; the bag fills them, lit to match the photo. The photo stays in the browser. */
(function(){
  var root=document.getElementById('nb');if(!root||!window.WNG)return;
  /* the discount is a thank-you for the tag and the campaign links (utm_campaign=nice-bike), not for everyone who opens this from the bag maker */
  (function(){
    var camp=/[?&]utm_campaign=nice-bike(&|$)/.test(location.search);
    try{if(camp)sessionStorage.setItem('wng-nb','1');camp=camp||sessionStorage.getItem('wng-nb')==='1'}catch(x){}
    if(!camp){var cb=root.querySelector('.nb-code');if(cb)cb.remove();root.setAttribute('data-code','')}
  })();
  var $=function(id){return document.getElementById(id)};
  var cv=$('nb-canvas'),g=cv.getContext('2d'),photo=document.createElement('canvas');
  var loupe=$('nb-loupe'),lg=loupe.querySelector('canvas').getContext('2d');
  var SAY=['Tap the inside corner under the seat, where the top tube meets the seat tube.','Tap the inside corner at the front, under the top tube.','Tap the inside corner at the front, above the down tube.','Tap the inside corner at the bottom, just above the cranks.'];
  var MAX=1600;/* longest photo side in px */
  var pts=[],drag=null,saving=false,adjusting=false,ok=false,logo=null,last=null,cur=null,sel=3,grabbed=false,sus=-1;
  var WHERE=['under the seat','at the front, under the top tube','at the front, above the down tube','at the bottom, just above the cranks'];
  var SHOP=window.WNG_SHOP||{variants:{}};
  var state={style:2,way:'#1E9E7A,#33307A,#D99A14,#D99A14',fabric:0};

  /* ---------- steps ---------- */
  function step(s){
    root.setAttribute('data-step',s);
    root.querySelector('.nb-start').hidden=s!=='start';
    root.querySelector('.nb-work').hidden=s==='start';
    $('nb-result').hidden=s!=='result';
    if(s==='result')adjusting=false;
    cv.classList.toggle('nb-touch',s==='tap'||adjusting);
  }
  function inResult(){return root.getAttribute('data-step')==='result'}
  function say(){
    var n=pts.length,done=n===4;
    var c=$('nb-count');c.hidden=done&&ok;c.textContent=done?'Check the corners':'Corner '+(n+1)+' of 4';
    /* a bad shape names the corner that looks wrong when it can tell; a tap on a placed dot says it is moving that one */
    var bad=sus<0?'Not a frame yet. Drag the dots onto the four inside corners, or start again.':'Corner '+(sus+1)+' looks off. It goes '+WHERE[sus]+'. Drag it there, or start again.';
    $('nb-say').textContent=grabbed&&drag!==null&&!done?'Moving corner '+(drag+1)+'. Let go where it fits.':done?(ok?(adjusting?'Drag a corner dot to fit the frame.':'Not quite right? Adjust the corners.'):bad):SAY[n];
    $('nb-undo').hidden=inResult();$('nb-fit').hidden=!inResult();$('nb-fit').textContent=adjusting?'Done':'Adjust';
    root.querySelectorAll('.nb-mini circle').forEach(function(c){var p=+c.getAttribute('data-p');c.setAttribute('class',p<n?'done':p===n?'now':'')});
    $('nb-undo').disabled=!n;
    /* four taps that make no frame: one button clears them all */
    var stuck=!inResult()&&done&&!ok;$('nb-clear').hidden=!stuck;$('nb-guide').classList.toggle('nb-bad',stuck);
    if(stuck)$('nb-undo').hidden=true;
  }
  function err(msg){var e=$('nb-err');e.textContent=msg||'';e.hidden=!msg}

  /* ---------- photo ---------- */
  function load(file){
    if(!file)return;err('');
    var url=URL.createObjectURL(file),im=new Image();
    im.onload=function(){
      var k=Math.min(1,MAX/Math.max(im.naturalWidth,im.naturalHeight));
      photo.width=cv.width=Math.round(im.naturalWidth*k);photo.height=cv.height=Math.round(im.naturalHeight*k);
      photo.getContext('2d').drawImage(im,0,0,photo.width,photo.height);URL.revokeObjectURL(url);
      pts=[];ok=false;step('tap');draw();say();
      root.querySelector('.nb-work').scrollIntoView({block:'start'});
    };
    im.onerror=function(){URL.revokeObjectURL(url);step('start');err('That photo would not open here. Take a new one, or choose a JPEG or PNG.')};
    im.src=url;
  }
  ['nb-cam','nb-pick','nb-again','nb-again2'].forEach(function(id){$(id).addEventListener('change',function(){load(this.files[0]);this.value=''})});

  /* ---------- tapping and dragging the four dots ---------- */
  function k(){var r=cv.getBoundingClientRect();return cv.width/r.width}
  function at(e){var r=cv.getBoundingClientRect(),s=cv.width/r.width;return [(e.clientX-r.left)*s,(e.clientY-r.top)*s]}
  /* while placing, a tap only grabs a dot it lands right on: the two front dots can sit 30px apart on a phone */
  function near(p){var best=null,bd=(pts.length<4?12:28)*k();pts.forEach(function(q,i){var d=Math.hypot(q[0]-p[0],q[1]-p[1]);if(d<bd){bd=d;best=i}});return best}
  cv.addEventListener('pointerdown',function(e){
    var tapping=root.getAttribute('data-step')==='tap',p=at(e),i=near(p);
    if(!tapping&&!adjusting)return;
    /* after the bag is drawn, only a dot can be dragged; anywhere else on the photo scrolls the page as usual */
    grabbed=i!==null;
    if(i===null){if(!tapping||pts.length>=4)return;pts.push(p);i=pts.length-1}
    drag=i;sel=i;cur=null;cv.setPointerCapture(e.pointerId);e.preventDefault();show(e);draw();say();
  });
  cv.addEventListener('pointermove',function(e){if(drag===null)return;pts[drag]=clampP(at(e));show(e);draw()});
  function up(){
    if(drag===null)return;drag=null;grabbed=false;loupe.classList.remove('on');settle();
  }
  /* four dots placed, or one moved: draw the bag when they make a frame */
  function settle(){
    if(pts.length===4&&root.getAttribute('data-step')==='tap'){draw();if(ok){step('result');publish();queueCard();var h=$('nb-h2');h.focus({preventScroll:true});
      /* desktop: the photo fills the screen, so bring the choices up under it */
      if(matchMedia('(min-width:821px) and (max-width:1099px)').matches)$('nb-styles').scrollIntoView({block:'nearest',behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'})}}
    /* a drag that leaves the dots in a bad shape keeps them showing until it is fixed */
    if(inResult()&&!ok)adjusting=true;
    draw();say();if(inResult())queueCard();
  }
  cv.addEventListener('touchstart',function(e){var t=e.touches[0];if(root.getAttribute('data-step')==='tap'||(adjusting&&near(at(t))!==null))e.preventDefault()},{passive:false});
  cv.addEventListener('pointerup',up);cv.addEventListener('pointercancel',up);
  function clampP(p){return [Math.max(0,Math.min(cv.width,p[0])),Math.max(0,Math.min(cv.height,p[1]))]}
  /* the loupe sits above the finger and shows the photo under it, twice as big, with a cross at the exact spot */
  function show(e){
    var p=pts[drag],stage=cv.parentNode.getBoundingClientRect(),r=cv.getBoundingClientRect(),s=k();
    var x=e.clientX-stage.left,y=e.clientY-stage.top-110;
    loupe.style.transform='translate('+Math.round(x-60)+'px,'+Math.round(Math.max(-40,y-60))+'px)';
    var src=60*s/2.2;
    lg.fillStyle='#14201D';lg.fillRect(0,0,240,240);
    lg.drawImage(photo,p[0]-src,p[1]-src,src*2,src*2,0,0,240,240);
    lg.strokeStyle='#fff';lg.lineWidth=5;lg.beginPath();lg.moveTo(120,96);lg.lineTo(120,144);lg.moveTo(96,120);lg.lineTo(144,120);lg.stroke();
    lg.strokeStyle='#A8146F';lg.lineWidth=2.5;lg.stroke();
    loupe.classList.add('on');
  }
  /* after the bag is drawn the dots are hidden so the bike can be seen; Adjust brings them back */
  $('nb-fit').addEventListener('click',function(){
    if(adjusting&&!ok)return;
    adjusting=!adjusting;cv.classList.toggle('nb-touch',adjusting);draw();say();
  });
  $('nb-undo').addEventListener('click',function(){
    pts.pop();if(root.getAttribute('data-step')==='result')step('tap')
    draw();say();
  });
  /* from the keyboard (detail 0), focus goes back to the photo; a tap leaves it, so the keyboard help stays hidden */
  $('nb-clear').addEventListener('click',function(e){pts=[];cur=null;draw();say();if(!e.detail)cv.focus({preventScroll:true})});

  /* the keyboard: arrows move a marker and Enter places it; once all four are down, 1 to 4 pick a corner and arrows move it */
  cv.addEventListener('keydown',function(e){
    var st=root.getAttribute('data-step'),key=e.key,n=pts.length,s=k()*(e.shiftKey?24:4),mv={ArrowLeft:[-s,0],ArrowRight:[s,0],ArrowUp:[0,-s],ArrowDown:[0,s]}[key];
    if(st==='start')return;
    if(/^[1-4]$/.test(key)&&+key<=n){
      sel=+key-1;if(inResult()&&!adjusting){adjusting=true;cv.classList.add('nb-touch')}
      e.preventDefault();draw();say();return;
    }
    if(st==='tap'&&n<4){
      if(!cur)cur=n?pts[n-1].slice():[cv.width/2,cv.height/2];
      if(mv){cur=clampP([cur[0]+mv[0],cur[1]+mv[1]]);e.preventDefault();draw()}
      else if(key==='Enter'||key===' '){pts.push(cur);sel=pts.length-1;cur=null;e.preventDefault();if(pts.length===4)settle();else{draw();say()}}
      else if(key==='Backspace'&&n){pts.pop();e.preventDefault();draw();say()}
      return;
    }
    if(mv){
      if(inResult()&&!adjusting){adjusting=true;cv.classList.add('nb-touch')}
      pts[sel]=clampP([pts[sel][0]+mv[0],pts[sel][1]+mv[1]]);e.preventDefault();
      if(inResult())settle();else{draw();say()}
    }else if(key==='Enter'){
      e.preventDefault();
      if(st==='tap')settle();else if(adjusting&&ok){adjusting=false;cv.classList.remove('nb-touch');draw();say()}
    }
  });
  cv.addEventListener('focus',function(){draw()});cv.addEventListener('blur',function(){draw()});

  function cols(){return state.way.split(',')}
  function idx(hex){for(var i=0;i<WNG.COLOURS.length;i++)if(WNG.COLOURS[i][1].toLowerCase()===hex.toLowerCase())return i;return 15}
  /* ---------- geometry, in photo pixels. A seat cluster, B top of the head tube, B2 bottom of the head tube, C bottom bracket ---------- */
  function sub(a,b){return [a[0]-b[0],a[1]-b[1]]}
  function dot(a,b){return a[0]*b[0]+a[1]*b[1]}
  function len(a){return Math.hypot(a[0],a[1])}
  function nrm(a){var l=len(a)||1;return [a[0]/l,a[1]/l]}
  function mix(a,b,t){return [a[0]+(b[0]-a[0])*t,a[1]+(b[1]-a[1])*t]}
  function clip(poly,p,n){var out=[];for(var i=0;i<poly.length;i++){var a=poly[i],b=poly[(i+1)%poly.length],da=(a[0]-p[0])*n[0]+(a[1]-p[1])*n[1],db=(b[0]-p[0])*n[0]+(b[1]-p[1])*n[1];if(da>=0)out.push(a);if((da>=0)!==(db>=0)){var t=da/(da-db);out.push([a[0]+(b[0]-a[0])*t,a[1]+(b[1]-a[1])*t])}}return out}
  function area(p){var s=0;for(var i=0;i<p.length;i++){var a=p[i],b=p[(i+1)%p.length];s+=a[0]*b[1]-b[0]*a[1]}return s/2}
  function inset(poly,d){var sgn=area(poly)>0?1:-1,out=poly;for(var i=0;i<poly.length;i++){var a=poly[i],b=poly[(i+1)%poly.length],ex=b[0]-a[0],ey=b[1]-a[1],l=Math.sqrt(ex*ex+ey*ey);if(l<1e-6)continue;var n=[-ey/l*sgn,ex/l*sgn];out=clip(out,[a[0]+n[0]*d,a[1]+n[1]*d],n)}return out}
  function centroid(p){var x=0,y=0;p.forEach(function(v){x+=v[0];y+=v[1]});return [x/p.length,y/p.length]}
  /* move each edge of a convex quad inward by d and intersect neighbours: tube centrelines to the inside of the tubes */
  function shrink(q,d){
    var sgn=area(q)>0?1:-1,L=q.map(function(a,i){var b=q[(i+1)%4],e=sub(b,a),l=len(e),n=[-e[1]/l*sgn,e[0]/l*sgn];return {p:[a[0]+n[0]*d,a[1]+n[1]*d],e:e}});
    return L.map(function(cur,i){var prev=L[(i+3)%4],den=prev.e[0]*cur.e[1]-prev.e[1]*cur.e[0];if(Math.abs(den)<1e-9)return cur.p;var w=sub(cur.p,prev.p),t=(w[0]*cur.e[1]-w[1]*cur.e[0])/den;return [prev.p[0]+prev.e[0]*t,prev.p[1]+prev.e[1]*t]});
  }
  function convex(q){var s=0;for(var i=0;i<q.length;i++){var a=q[i],b=q[(i+1)%q.length],c=q[(i+2)%q.length],z=(b[0]-a[0])*(c[1]-b[1])-(b[1]-a[1])*(c[0]-b[0]);if(Math.abs(z)<1e-6)return false;if(!s)s=Math.sign(z);else if(Math.sign(z)!==s)return false}return true}
  /* square off the corner of a convex polygon nearest p, leaving an end w wide (bags stop short of tight corners) */
  function cutCorner(poly,p,w){
    var i=0,bd=1e12;poly.forEach(function(v,j){var d=len(sub(v,p));if(d<bd){bd=d;i=j}});
    var v=poly[i],a=nrm(sub(poly[(i+poly.length-1)%poly.length],v)),c=nrm(sub(poly[(i+1)%poly.length],v));
    var bis=nrm([a[0]+c[0],a[1]+c[1]]),half=Math.acos(Math.max(-1,Math.min(1,dot(a,c))))/2;if(half<0.05)return poly;
    var d=(w/2)/Math.tan(half);
    return clip(poly,[v[0]+bis[0]*d,v[1]+bis[1]*d],bis);
  }

  /* the four taps as a frame; null when the dots are not a believable frame */
  function basis(){
    var A=pts[0],B=pts[1],B2=pts[2],C=pts[3],T=len(sub(B,A));if(T<40)return null;
    var ex=[(B[0]-A[0])/T,(B[1]-A[1])/T],ey=[-ex[1],ex[0]];
    if(dot(sub(C,A),ey)>0)ey=[-ey[0],-ey[1]];
    var fx=function(p){return dot(sub(p,A),ex)},fy=function(p){return dot(sub(p,A),ey)};
    if(!convex([A,B,B2,C])||fy(C)>-0.25*T||len(sub(B2,B))>0.6*T||fx(C)>fx(B2)||fx(C)<-0.35*T)return null;
    return {A:A,B:B,B2:B2,C:C,ex:ex,ey:ey,T:T,fx:fx,fy:fy,drive:ex[0]>=0};
  }

  /* which corner makes the shape fail, for the message and a yellow dot; -1 when it cannot tell (two corners swapped, say) */
  function suspect(){
    var A=pts[0],B=pts[1],B2=pts[2],C=pts[3],T=len(sub(B,A));if(T<40)return 1;
    var z=pts.map(function(b,i){var a=pts[(i+3)%4],c=pts[(i+1)%4];return (b[0]-a[0])*(c[1]-b[1])-(b[1]-a[1])*(c[0]-b[0])});
    for(var i=0;i<4;i++)if(Math.abs(z[i])<1e-6)return i;
    var pos=z.filter(function(v){return v>0}).length;
    if(pos===1||pos===3){for(i=0;i<4;i++)if((z[i]>0)===(pos===1))return i}
    var ex=[(B[0]-A[0])/T,(B[1]-A[1])/T],ey=[-ex[1],ex[0]];if(dot(sub(C,A),ey)>0)ey=[-ey[0],-ey[1]];
    var fx=function(p){return dot(sub(p,A),ex)},fy=function(p){return dot(sub(p,A),ey)};
    if(len(sub(B2,B))>0.6*T)return 2;
    if(fy(C)>-0.25*T||fx(C)>fx(B2)||fx(C)<-0.35*T)return 3;
    /* two corners swapped: no one corner to name */
    return -1;
  }

  /* the bag: the inside of the frame, squared off at the bottom bracket and the head tube, split into panels by zips */
  function bag(b){
    var T=b.T,r=T*0.004,q=shrink([b.A,b.B,b.B2,b.C],r);
    if(!convex(q))return null;
    var poly=cutCorner(q.slice(),q[3],T*0.05);
    poly=cutCorner(poly,q[2],T*0.035);poly=cutCorner(poly,q[0],T*0.02);poly=cutCorner(poly,q[1],T*0.02);
    if(state.style===0){
      var L=mix(q[0],q[3],0.46),R=mix(q[2],q[3],0.42),n=[-(R[1]-L[1]),R[0]-L[0]];
      if(dot(sub(q[0],L),n)<0)n=[-n[0],-n[1]];
      poly=clip(poly,L,nrm(n));
    }
    var ys=poly.map(b.fy),top=Math.max.apply(null,ys),bot=Math.min.apply(null,ys),h=top-bot;
    function at(y){return [b.A[0]+b.ey[0]*y,b.A[1]+b.ey[1]*y]}
    function below(p,y){return clip(p,at(y),[-b.ey[0],-b.ey[1]])}
    function above(p,y){return clip(p,at(y),b.ey)}
    var z1=top-h*(state.style===0?0.42:0.25),z2=top-h*0.62,bands,lines=[{y:z1,zip:true}];
    /* every panel shows whichever side the photo is from, so all the chosen colours are seen */
    if(state.style===0)bands=[above(poly,z1),below(poly,z1)];
    else{bands=[above(poly,z1),above(below(poly,z1),z2),below(poly,z2)];lines.push({y:z2,zip:state.style===2})}
    return {poly:poly,q:q,r:r,top:top,bot:bot,h:h,bands:bands,lines:lines,at:at,below:below,above:above};
  }

  /* the photo's light around the frame: how bright, and its colour cast, so the bag sits in the same light */
  var light=null;
  function measure(b){
    var xs=[b.A[0],b.B[0],b.B2[0],b.C[0]],ys=[b.A[1],b.B[1],b.B2[1],b.C[1]];
    var x0=Math.max(0,Math.floor(Math.min.apply(null,xs))),y0=Math.max(0,Math.floor(Math.min.apply(null,ys)));
    var w=Math.min(photo.width,Math.ceil(Math.max.apply(null,xs)))-x0,h=Math.min(photo.height,Math.ceil(Math.max.apply(null,ys)))-y0;
    if(w<4||h<4)return {k:1,t:[1,1,1]};
    var d=photo.getContext('2d').getImageData(x0,y0,w,h).data,s=[0,0,0],n=0,step=4*Math.max(1,Math.floor(w*h/4000));
    for(var i=0;i<d.length;i+=step){s[0]+=d[i];s[1]+=d[i+1];s[2]+=d[i+2];n++}
    s=s.map(function(v){return v/n/255});var lum=0.299*s[0]+0.587*s[1]+0.114*s[2]||0.01;
    return {k:Math.max(0.58,Math.min(1.04,0.42+lum*1.05)),t:s.map(function(v){return 1+0.35*(v/lum-1)})};
  }
  function lit(hex){
    var n=parseInt(hex.slice(1),16),c=[n>>16&255,n>>8&255,n&255];
    return 'rgb('+c.map(function(v,i){return Math.max(0,Math.min(255,Math.round(v*light.k*light.t[i])))}).join(',')+')';
  }
  var grain=(function(){var c=document.createElement('canvas');c.width=c.height=96;var x=c.getContext('2d'),im=x.createImageData(96,96);for(var i=0;i<im.data.length;i+=4){var v=110+Math.random()*36;im.data[i]=im.data[i+1]=im.data[i+2]=v;im.data[i+3]=255}x.putImageData(im,0,0);return c})();

  /* ---------- drawing ---------- */
  function poly(p){g.beginPath();p.forEach(function(v,i){i?g.lineTo(v[0],v[1]):g.moveTo(v[0],v[1])});g.closePath()}
  function quad(p,e,n,w,i0,i1){poly([[p[0]-e[0]*w+n[0]*i0,p[1]-e[1]*w+n[1]*i0],[p[0]+e[0]*w+n[0]*i0,p[1]+e[1]*w+n[1]*i0],[p[0]+e[0]*w+n[0]*i1,p[1]+e[1]*w+n[1]*i1],[p[0]-e[0]*w+n[0]*i1,p[1]-e[1]*w+n[1]*i1]])}
  function drawBag(b){
    var m=bag(b);if(!m)return false;last=m.poly;
    var c=cols(),T=b.T,ctr=centroid(m.poly);light=measure(b);
    g.save();g.lineJoin='round';g.lineCap='round';
    /* a soft contact shadow, then the panels */
    g.shadowColor='rgba(0,0,0,.42)';g.shadowBlur=T*0.035;g.shadowOffsetY=T*0.01;
    g.fillStyle=lit(c[0]);poly(m.poly);g.fill();
    g.shadowColor='transparent';
    g.save();poly(m.poly);g.clip();
    m.bands.forEach(function(p,i){if(p.length<3)return;g.fillStyle=lit(c[i]);poly(p);g.fill()});
    /* zips and the seam, with a zip cover and a pull at the head-tube end */
    m.lines.forEach(function(l){
      var hz=l.zip?T*0.0065:T*0.0022,strip=m.above(m.below(m.poly,l.y+hz),l.y-hz);
      g.fillStyle=lit('#141416');poly(strip);g.fill();
      if(!l.zip)return;
      var front=strip.reduce(function(a,v){return b.fx(v)>b.fx(a)?v:a},strip[0]),xp=b.fx(front)-T*0.07;
      var cover=clip(clip(m.above(m.below(m.poly,l.y+T*0.022),l.y-T*0.022),[b.A[0]+b.ex[0]*xp,b.A[1]+b.ex[1]*xp],b.ex),[b.A[0]+b.ex[0]*(xp+T*0.1),b.A[1]+b.ex[1]*(xp+T*0.1)],[-b.ex[0],-b.ex[1]]);
      if(cover.length>2){g.fillStyle=lit(c[3]);poly(cover);g.fill()}
      var pp=m.at(l.y),pc=[pp[0]+b.ex[0]*(xp-T*0.02),pp[1]+b.ex[1]*(xp-T*0.02)];
      g.fillStyle=lit('#B9BEBB');quad(pc,b.ex,b.ey,T*0.018,-T*0.007,T*0.007);g.fill();
    });
    /* fabric: weave grain, light from above, and edges that fall away like a packed bag */
    g.globalCompositeOperation='soft-light';g.globalAlpha=0.55;g.fillStyle=g.createPattern(grain,'repeat');poly(m.poly);g.fill();
    g.globalCompositeOperation='source-over';g.globalAlpha=1;
    var tp=m.at(m.top),bp=m.at(m.bot),lg=g.createLinearGradient(tp[0],tp[1],bp[0],bp[1]);
    lg.addColorStop(0,'rgba(255,255,255,.13)');lg.addColorStop(0.45,'rgba(255,255,255,0)');lg.addColorStop(1,'rgba(0,0,0,.2)');
    g.fillStyle=lg;poly(m.poly);g.fill();
    [0.075,0.05,0.03,0.015].forEach(function(w){g.lineWidth=T*w;g.strokeStyle='rgba(0,0,0,.075)';poly(m.poly);g.stroke()});
    g.restore();
    /* binding and stitching */
    g.lineWidth=T*0.009;g.strokeStyle=lit('#18181b');poly(m.poly);g.stroke();
    g.setLineDash([T*0.012,T*0.009]);g.lineWidth=Math.max(1,T*0.0025);g.strokeStyle='rgba(255,255,255,.32)';poly(inset(m.poly,T*0.02));g.stroke();g.setLineDash([]);
    /* woven patch with the logo, upright along the top tube, on the panel below the top zip */
    var band=m.bands[1];
    if(logo&&logo.complete&&band&&band.length>2){
      var bc=centroid(band),bys=band.map(b.fy),bh=Math.max.apply(null,bys)-Math.min.apply(null,bys);
      var pw=Math.min(T*0.12,bh*0.55/0.84),ph=pw*0.84,pc2=mix(bc,b.A,0.28);
      g.translate(pc2[0],pc2[1]);g.rotate(Math.atan2(b.ex[1],b.ex[0])+(b.ex[0]<0?Math.PI:0));
      g.fillStyle=lit('#15151A');g.beginPath();if(g.roundRect)g.roundRect(-pw/2,-ph/2,pw,ph,pw*0.08);else g.rect(-pw/2,-ph/2,pw,ph);g.fill();
      g.globalAlpha=0.92;g.drawImage(logo,-pw*0.42,-ph*0.42,pw*0.84,ph*0.84);g.globalAlpha=1;
    }
    g.restore();
    return true;
  }
  function drawDots(){
    var s=k(),r=14*s;
    /* once the bag is drawn the dots shrink to handles on its corners */
    var kb=document.activeElement===cv&&cv.matches(':focus-visible'),hot=function(i){return i===drag||(kb&&drag===null&&i===sel&&pts.length===4)||(drag===null&&i===sus)};
    if(ok&&inResult()){if(!adjusting)return;pts.forEach(function(p,i){g.beginPath();g.arc(p[0],p[1],9*s,0,7);g.fillStyle=hot(i)?'#DDBB10':'#fff';g.fill();g.lineWidth=3*s;g.strokeStyle='#A8146F';g.stroke()});return}
    if(pts.length>1){g.save();g.lineWidth=2.5*s;g.setLineDash([8*s,6*s]);g.strokeStyle='rgba(255,255,255,.9)';g.beginPath();pts.forEach(function(p,i){i?g.lineTo(p[0],p[1]):g.moveTo(p[0],p[1])});if(pts.length===4)g.closePath();g.stroke();g.restore()}
    g.font='600 '+Math.round(15*s)+'px "Geist Mono",monospace';g.textAlign='center';g.textBaseline='middle';
    pts.forEach(function(p,i){
      g.beginPath();g.arc(p[0],p[1],r,0,7);g.fillStyle=hot(i)?'#DDBB10':'#A8146F';g.fill();g.lineWidth=3*s;g.strokeStyle='#fff';g.stroke();
      g.fillStyle=hot(i)?'#15151A':'#fff';g.fillText(String(i+1),p[0],p[1]+s);
    });
    /* the keyboard marker for the next corner: a ring with a cross */
    if(kb&&cur&&pts.length<4){
      g.lineWidth=3*s;g.strokeStyle='#fff';g.beginPath();g.arc(cur[0],cur[1],r,0,7);g.stroke();
      g.strokeStyle='#A8146F';g.lineWidth=2*s;g.beginPath();g.moveTo(cur[0]-r*1.6,cur[1]);g.lineTo(cur[0]+r*1.6,cur[1]);g.moveTo(cur[0],cur[1]-r*1.6);g.lineTo(cur[0],cur[1]+r*1.6);g.stroke();
    }
  }
  function draw(){
    g.setTransform(1,0,0,1,0,0);g.drawImage(photo,0,0);
    var b=pts.length===4?basis():null;
    ok=!!b&&drawBag(b);
    sus=pts.length===4&&!ok?suspect():-1;
    if(!saving)drawDots();
    price();
  }

  /* ---------- choices ---------- */
  root.querySelectorAll('input[name="nb-style"]').forEach(function(r){r.addEventListener('change',function(){state.style=+this.value;moved=0;chips();draw();queueCard()})});
  /* only colourways the fabric really comes in (theme setting "Colours per fabric"), so the bag maker keeps them as shown */
  var first=null,pref=0;
  try{var dd=JSON.parse(localStorage.getItem('wng-design')||'null');if(dd&&dd.fabric>=0&&dd.fabric<WNG.FABRICS.length)pref=dd.fabric}catch(x){}
  function fabFor(v){
    var js=v.split(',').map(idx),order=[pref].concat(WNG.FABRICS.map(function(f,i){return i}));
    for(var i=0;i<order.length;i++){var a=WNG.offered(order[i]);if(js.every(function(j){return a.indexOf(j)>=0}))return order[i]}
    return -1;
  }
  root.querySelectorAll('input[name="nb-way"]').forEach(function(r){
    var f=fabFor(r.value);
    if(f<0){r.parentNode.hidden=true;r.checked=false;return}
    r.setAttribute('data-f',f);
    if(!first)first=r;
    r.addEventListener('change',function(){var was=priceOf();state.way=this.value;state.fabric=f;moved=was!==null&&priceOf()!==null?priceOf()-was:0;draw();queueCard()});
  });
  /* coming from the bag maker: start on the style they picked there, and their colours when they match one of these */
  (function(){
    var d=null;try{d=JSON.parse(localStorage.getItem('wng-design')||'null')}catch(x){}
    if(!d)return;
    if(d.style===0||d.style===1||d.style===2){var sr=root.querySelector('input[name="nb-style"][value="'+d.style+'"]');if(sr){sr.checked=true;state.style=d.style}}
    if(!d.cols||d.mode)return;
    root.querySelectorAll('input[name="nb-way"]').forEach(function(r){
      if(r.parentNode.hidden)return;
      if(r.value.split(',').slice(0,3).every(function(h,i){return idx(h)===d.cols[i]}))first=r;
    });
  })();
  if(first){first.checked=true;state.way=first.value;state.fabric=+first.getAttribute('data-f')}
  chips();
  /* each colourway comes in one fabric, so picking colours can change the fabric and the price: the line says both, and by how much it moved */
  var moved=0;
  function priceOf(f){var v=SHOP.variants[WNG.STYLES[state.style]+' / '+WNG.FABRICS[f==null?state.fabric:f]];return v?Math.round(v.price/100):null}
  /* "600denier Poly (Standard)" reads as "600 denier Poly" */
  function fabName(f){return WNG.FABRICS[f].replace(' (Standard)','').replace(/(\d)denier/,'$1 denier')}
  /* every colour button says its fabric and price before it is picked */
  function chips(){
    root.querySelectorAll('input[name="nb-way"]').forEach(function(r){
      var f=r.getAttribute('data-f'),sm=r.parentNode.querySelector('.nb-wf');if(f==null||!sm)return;
      var p=priceOf(+f);sm.innerHTML='<span class="nb-wfab">'+fabName(+f).split(' ').pop()+'</span>'+(p!==null?'<span class="nb-wsep"> \u00B7 </span>$'+p:'');
    });
  }
  function price(){
    var p=priceOf(),w=root.querySelector('input[name="nb-way"]:checked'),name=w?w.getAttribute('aria-label'):'';
    var t=name+' in '+fabName(state.fabric)+(p!==null?' \u00B7 $'+p+' '+(SHOP.currency||''):'')+(moved?' ('+(moved>0?'+':'\u2212')+'$'+Math.abs(moved)+')':'');
    if($('nb-price').textContent!==t)$('nb-price').textContent=t;
  }

  /* the logo, from the page's SVG symbol, white on a black woven patch */
  (function(){
    var sym=document.getElementById('wng-logo');if(!sym)return;var clips='';
    document.querySelectorAll('clipPath').forEach(function(c){clips+=c.outerHTML});
    logo=new Image();logo.onload=function(){if(pts.length===4)draw()};
    logo.src='data:image/svg+xml;charset=utf-8,'+encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 470.435 396.111" width="470" height="396" style="color:#FFFFFF"><defs>'+clips+'</defs>'+sym.innerHTML+'</svg>');
  })();

  /* ---------- build it: style and colours go to the bag maker; frame lengths stay whatever they measure ---------- */
  $('nb-build').addEventListener('click',function(){
    try{
      var d=JSON.parse(localStorage.getItem('wng-design')||'null')||{};
      d.style=state.style;d.cols=cols().map(idx);d.mode=0;d.fabric=state.fabric;if(d.patch==null)d.patch=0;
      localStorage.setItem('wng-design',JSON.stringify(d));
    }catch(x){}
    /* the frame's shape from the taps (inside corners: seat, head tube top, head tube bottom, bottom bracket), scaled to a 540 top tube, and what was picked */
    try{
      var L=function(a,b){return Math.hypot(pts[a][0]-pts[b][0],pts[a][1]-pts[b][1])},k=540/L(0,1),w=root.querySelector('input[name="nb-way"]:checked');
      var r=function(v){return Math.round(v*k)};
      localStorage.setItem('wng-nb',JSON.stringify({t:Date.now(),shape:{tt:540,ht:r(L(1,2)),dt:r(L(2,3)),st:r(L(3,0))},
        what:['Half Frame, 2 pocket,','Full Frame, 2 pocket,','Full Frame, 3 pocket,'][state.style]+' in '+(w?w.getAttribute('aria-label').toLowerCase().replace(/, ([^,]*)$/,' and $1'):'')}));
    }catch(x){}
    /* the bike with the bag drawn in, so the bag maker and the order page can show it while the choices still match */
    try{if(!ok)throw 0;localStorage.setItem('wng-nbshot',JSON.stringify({t:Date.now(),style:state.style,cols:cols().map(idx),img:bikeShot(720,1.25).toDataURL('image/jpeg',0.82)}))}catch(x){try{localStorage.removeItem('wng-nbshot')}catch(y){}}
    /* the photo, kept on this device so the order page can offer to send it */
    try{
      var s=Math.min(1,1280/Math.max(photo.width,photo.height)),c=document.createElement('canvas');c.width=Math.round(photo.width*s);c.height=Math.round(photo.height*s);
      c.getContext('2d').drawImage(photo,0,0,c.width,c.height);
      localStorage.setItem('wng-bikephoto',JSON.stringify({t:Date.now(),img:c.toDataURL('image/jpeg',0.8)}));
    }catch(x){try{localStorage.removeItem('wng-bikephoto')}catch(y){}}
    var code=root.getAttribute('data-code'),maker=root.getAttribute('data-maker');
    if(code)this.href='/discount/'+encodeURIComponent(code)+'?redirect='+encodeURIComponent(maker);
  });
  function publish(){try{window.Shopify&&Shopify.analytics&&Shopify.analytics.publish&&Shopify.analytics.publish('nice_bike_drawn',{style:state.style})}catch(x){}}

  /* ---------- the picture to save or share: a 4:5 card on the cutting mat with the bike, the name, and a QR code back here ----------
     Made ahead of the tap, so the share sheet opens straight from the button (Safari drops it after an async wait). */
  var QR={n:41,hex:'fe95e4123fc1560904906ea243342bb74c97ee95dbafd3445aec13b44b0507faaaaaaafe002c1692009f9371bdcb98e9d9ab8c15ab90550accb52a06bc9dee03988b03066408d2d5ecbbf0c7cb4ba03321ad129f9bd2c1fed4df2be41ab4e577c6b00fdd497567b14103d23d299f91b8f1192235f9e16b60a23ad9da6a9889b13a2763ad5567e5243fe734bad2106bf26589ad195629cce3bce39ae9d5450bab69358557eb144ba5fb807198b8453fbad857ea1058e960b19bad96199fddd7620bf496e825ebc36304ba44541dfea269c18c0'},cardFile=null,cardTimer=null,cardRun=0;
  function queueCard(){cardFile=null;clearTimeout(cardTimer);cardTimer=setTimeout(makeCard,350)}
  function wrap(x,text,maxW){var words=text.split(' '),lines=[],line='';words.forEach(function(w){var t=line?line+' '+w:w;if(x.measureText(t).width>maxW&&line){lines.push(line);line=w}else line=t});if(line)lines.push(line);return lines}
  /* the bike and its bag, without the dots */
  function clean(){saving=true;draw();var s=document.createElement('canvas');s.width=cv.width;s.height=cv.height;s.getContext('2d').drawImage(cv,0,0);saving=false;draw();return s}
  /* crop around the bike: about two and a half bags wide, a little below the bag to take in the wheels */
  function crop(shot,ar){
    var xs=last.map(function(v){return v[0]}),ys=last.map(function(v){return v[1]});
    var bx0=Math.min.apply(null,xs),bx1=Math.max.apply(null,xs),by0=Math.min.apply(null,ys),by1=Math.max.apply(null,ys);
    var cw=Math.min(shot.width,(bx1-bx0)*2.7),ch=cw/ar;
    if(ch>shot.height){ch=shot.height;cw=Math.min(shot.width,ch*ar);ch=cw/ar}
    return [Math.max(0,Math.min(shot.width-cw,(bx0+bx1)/2-cw/2)),Math.max(0,Math.min(shot.height-ch,(by0+by1)/2+(by1-by0)*0.3-ch/2)),cw,ch];
  }
  function bikeShot(W,ar){var s=clean(),c=crop(s,ar),o=document.createElement('canvas');o.width=W;o.height=Math.round(W/ar);o.getContext('2d').drawImage(s,c[0],c[1],c[2],c[3],0,0,o.width,o.height);return o}
  function makeCard(){
    if(!ok||!last)return;var run=++cardRun;
    var W=1080,H=1350,P=64,out=document.createElement('canvas'),x=out.getContext('2d');out.width=W;out.height=H;
    var shot=clean(),fw=W-P*2,fh=Math.round(fw*0.8),cr=crop(shot,fw/fh),cx=cr[0],cy=cr[1],cw=cr[2],ch=cr[3];
    /* mat with its grid */
    x.fillStyle='#14201D';x.fillRect(0,0,W,H);
    for(var gx=0;gx<=W;gx+=24){x.fillStyle=gx%120?'rgba(255,255,255,.06)':'rgba(255,255,255,.14)';x.fillRect(gx,0,1.5,H)}
    for(var gy=0;gy<=H;gy+=24){x.fillStyle=gy%120?'rgba(255,255,255,.06)':'rgba(255,255,255,.14)';x.fillRect(0,gy,W,1.5)}
    /* logo and where it is made */
    if(logo&&logo.complete)x.drawImage(logo,P,40,150,150*396.111/470.435);
    x.fillStyle='#B4C1BB';x.textAlign='right';x.textBaseline='alphabetic';x.font='500 24px "Geist Mono",monospace';
    x.fillText('HANDMADE FRAME BAGS',W-P,96);x.fillText('CANMORE, ALBERTA',W-P,130);
    /* the photo, set in a sheet of pattern paper with a stitch line round it */
    var fy=196;
    x.fillStyle='#F6F7F4';x.fillRect(P,fy,fw,fh);
    x.drawImage(shot,cx,cy,cw,ch,P+12,fy+12,fw-24,fh-24);
    x.setLineDash([14,10]);x.lineWidth=2;x.strokeStyle='rgba(238,242,239,.45)';x.strokeRect(P-14,fy-14,fw+28,fh+28);x.setLineDash([]);
    /* the words */
    var ty=fy+fh+128;x.textAlign='left';x.fillStyle='#EEF2EF';
    /* setting font resets fontStretch, so the narrow cut goes on after it */
    x.font='800 140px "Bricolage Grotesque",sans-serif';if('fontStretch' in x)x.fontStretch='condensed';x.fillText('Nice bike.',P-4,ty);
    if('fontStretch' in x)x.fontStretch='normal';
    var styleName=['Half frame bag, 2 pocket,','Full frame bag, 2 pocket,','Full frame bag, 3 pocket,'][state.style],w=root.querySelector('input[name="nb-way"]:checked');
    var colours=w?w.getAttribute('aria-label').toLowerCase().replace(/, ([^,]*)$/,' and $1'):'';
    x.font='400 30px Geist,sans-serif';x.fillStyle='#B4C1BB';
    /* two lines of about equal length, never one word left on the second */
    var cap=styleName+' in '+colours+'.',mw=690;if(wrap(x,cap,mw).length===2)while(mw>300&&wrap(x,cap,mw-10).length===2)mw-=10;
    wrap(x,cap,mw).slice(0,2).forEach(function(l,i){x.fillText(l,P,ty+52+i*40)});
    x.font='600 34px Geist,sans-serif';x.fillStyle='#EEF2EF';x.fillText('wildnorthgear.co',P,H-62);
    /* QR code on a white tag, back to this page */
    var qs=212,qx=W-P-qs,qy=fy+fh+44,mod=(qs-28)/QR.n;
    x.fillStyle='#FFFFFF';x.fillRect(qx,qy,qs,qs);x.fillStyle='#15151A';
    for(var i=0;i<QR.n*QR.n;i++){if(parseInt(QR.hex[i>>2],16)&(8>>(i&3)))x.fillRect(qx+14+(i%QR.n)*mod,qy+14+Math.floor(i/QR.n)*mod,Math.ceil(mod),Math.ceil(mod))}
    x.font='500 22px "Geist Mono",monospace';x.fillStyle='#B4C1BB';x.textAlign='center';x.fillText('TRY IT ON YOUR BIKE',qx+qs/2,qy+qs+40);
    out.toBlob(function(blob){if(blob&&run===cardRun)cardFile=new File([blob],'wild-north-gear-nice-bike.jpg',{type:'image/jpeg'})},'image/jpeg',0.92);
  }
  if(document.fonts&&document.fonts.load){['800 140px "Bricolage Grotesque"','condensed 800 140px "Bricolage Grotesque"','400 30px Geist','600 34px Geist','500 22px "Geist Mono"'].forEach(function(f){document.fonts.load(f).catch(function(){})})}
  $('nb-save').addEventListener('click',function(){
    var btn=this;
    function give(file){
      if(navigator.canShare&&navigator.canShare({files:[file]})){navigator.share({files:[file],text:'A Wild North Gear frame bag on my bike. wildnorthgear.co'}).catch(function(){});return}
      var a=document.createElement('a');a.href=URL.createObjectURL(file);a.download=file.name;document.body.appendChild(a);a.click();
      setTimeout(function(){URL.revokeObjectURL(a.href);a.remove()},1000);
      var t=btn.innerHTML;btn.textContent='Saved';setTimeout(function(){btn.innerHTML=t},2000);
    }
    if(cardFile){give(cardFile);return}
    /* not ready yet (a change a moment ago): make it now; a download still works where sharing needs a fresh tap */
    clearTimeout(cardTimer);makeCard();var tries=0;(function wait(){if(cardFile)give(cardFile);else if(tries++<40)setTimeout(wait,50)})();
  });

  step('start');
})();
